import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const RmTickets = ({
  fetchEmTicket,
  employeeTicket,
  getEmployeeFilterDropDown,
  employeeFilterList,
}) => {
  const headers = [
    'Ticket ID',
    'Site Number',
    'Site Type',
    'Remarks',
    'Created At',
    'Assigned To',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
        setIsRoleId(roles);
      })();
    }, 1000);
  }, []);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchEmTicket(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      if (fetchEmTicket) {
        setIsLoading(true);
        await fetchEmTicket();
        await getEmployeeFilterDropDown();
        setIsLoading(false);
      }
    })();
  }, [fetchEmTicket]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchEmTicket(filterData,val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      { name: 'View Details', link: '/dashboard/em-view-details' },
      { name: 'Assign Ticket', link: '/dashboard/em-assign-ticket' },
    ];

    const actions = [
      { name: 'View Details', link: '/dashboard/em-view-details' },
    ];

    const tableData = [
      'id',
      'site_no',
      'site_type',
      'remarks',
      'created_at',
      'assigned_to',
      'status',
    ];

    if (employeeTicket && employeeTicket.resultSets) {
      const data = employeeTicket.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: isRoleId === 9 ? actions : actions1,
          }
        )
      );
      if (data.length > 0) {
        setListData(data);
      }

      setPageCount(Math.ceil(employeeTicket.total / employeeTicket.per_page));
    }
  }, [employeeTicket]);

  return (
    <Layout
      title={localization.employeeTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={employeeTicket?.from}
        onPageChange={onPageChange}
        detailList={employeeTicket && employeeTicket.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={0}
        listFilterData={employeeFilterList?.sites ? employeeFilterList : null}
        employeeFilterList
      />
    </Layout>
  );
};

export default RmTickets;
